import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { RequestReportModal } from "./RequstReportModal";
import { HTMLAttributes } from "react";

export const RequestReportButton: React.FC<HTMLAttributes<HTMLElement>> = observer(({ ...props }) => {
  const { actionModals } = useStores();

  const requestReportHandler = () => {
    actionModals.open(() => <RequestReportModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: `Отчет о заявках`,
      onClose: () => actionModals.closeAll(),
    });
  };

  return (
    <CustomButton onClick={requestReportHandler} type="default" className={props.className}>
      Отчет о заявках
    </CustomButton>
  );
});
